/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useHistory, useParams } from "react-router-dom"
import { Button } from "@chakra-ui/react"
import { Controller, useForm } from "react-hook-form"
import _ from "lodash"
import { Input } from "antd"

import Layout from "../../components/layout/GeneralLayout"
import SpinnerLoading from "../../components/Loading/SpinnerLoading"
import Alert from "../../components/common/Alert/AlertDialog"
import DialogLoading from "../../components/Loading/DialogLoading"
import * as actions from "../../redux/actions"

export default function CreateOrEditCategoryArticle({ type = "create" }) {
  const dispatch = useDispatch()
  const history = useHistory()
  const params = useParams()
  const articleCategories = useSelector((state) => state.articleCategories)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [errMessage, setErrMessage] = useState()
  const [isLoadingDialogOpen, setIsLoadingDialogOpen] = useState(false)
  const { handleSubmit, control } = useForm()
  console.log(" articleCategories: ", articleCategories)

  useEffect(() => {
    if (type === "create") {
      setIsLoading(true)
    }
    return () => {}
  }, [type])

  useEffect(() => {
    dispatch(actions.getOneArticleCategory(params?.id))
    return () => {}
  }, [])

  useEffect(() => {
    if (params?.id) {
      dispatch(actions.getOneArticleCategory(params?.id))
        .then(() => {
          setIsLoading(true)
        })
        .catch((err) => {
          setErrMessage(err)
          setIsError(true)
        })
    }
    return () => {}
  }, [params])

  const onCreateArticle = (data) => {
    setIsLoadingDialogOpen(true)

    dispatch(actions.createOneArticle(data))
      .then(() => {
        setIsLoadingDialogOpen(false)
        history.goBack()
      })
      .catch((err) => {
        setIsLoadingDialogOpen(false)
        setErrMessage(err)
        setIsError(true)
      })
  }

  const onEditArticle = (data) => {
    dispatch(actions.editOneArticleCategory(params?.id, data))
      .then(() => {
        history.goBack()
        setIsLoadingDialogOpen(false)
      })
      .catch((err) => {
        setIsLoadingDialogOpen(false)
        setErrMessage(err)
        setIsError(true)
      })

    setTimeout(() => {
      setIsLoadingDialogOpen(false)
    }, 300000)
  }

  const isEditMode = type === "edit"

  if (isLoading === false) {
    return (
      <div>
        <SpinnerLoading />
        <Alert
          isError={isError}
          errMessage={errMessage}
          handleOnClose={() => {
            setIsError(false)
            setErrMessage()
          }}
        />
      </div>
    )
  }

  return (
    <Layout
      categoryTitle="จัดการเว็บไซต์โรงแรม > บทความ"
      title={type === "create" ? "เพิ่มบทความ" : "แก้ไขบทความ"}
    >
      <Alert
        isError={isError}
        errMessage={errMessage}
        handleOnClose={() => {
          setIsError(false)
          setErrMessage()
        }}
      />
      <DialogLoading isLoading={isLoadingDialogOpen} />

      <div className="flex justify-between px-4">
        <Button
          colorScheme="purple"
          variant="outline"
          onClick={() => {
            history.goBack()
          }}
        >
          กลับ
        </Button>
      </div>

      <div className="p-4 w-full">
        <div className="flex flex-wrap justify-between pb-8">
          <div className="w-full  ">
            <form onSubmit={handleSubmit(isEditMode ? onEditArticle : onCreateArticle)}>
              <div className="flex flex-wrap bg-white p-4 rounded-lg shadow-lg">
                <div className="w-full px-4 ">
                  <div className="relative w-full mb-3 ">
                    <label className="block uppercase text-gray-700  font-semibold mb-2 text-lg">
                      ชื่อหมวดหมู่บทความ <span className="text-red-400">*</span>
                    </label>
                    <label
                      className="block  text-gray-700 text-sm font-semibold mb-2 pt-4 pb-1"
                      htmlFor="grid-password "
                    >
                      ภาษาไทย *
                    </label>
                    <Controller
                      name="translation.th.name"
                      control={control}
                      defaultValue={isEditMode ? articleCategories?.translation?.th?.name : ""}
                      render={(field) => (
                        <Input {...field} placeholder="ชื่อบทความ" required size="large" />
                      )}
                    />

                    <label className="block  text-gray-700 text-sm font-semibold mb-2 pt-4">
                      ภาษาอังกฤษ
                    </label>
                    <Controller
                      name="translation.en.name"
                      control={control}
                      defaultValue={isEditMode ? articleCategories?.translation?.en?.name : ""}
                      render={(field) => <Input {...field} placeholder="ชื่อบทความ" size="large" />}
                    />
                  </div>

                  <br />

                  <div className="text-center  gap-0 py-3 ">
                    <Button isFullWidth colorScheme="purple" variant="solid" type="submit">
                      {isEditMode ? "แก้ไข" : "เพิ่ม"}
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  )
}
